// Romea Meet Bridge Configuration
// NO KEYS HARDCODED — Vapi public key injected at build time via import.meta.env

export const CLAW_BASE_URL =
  (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('clawBase')) ||
  'https://ai.romea.ai'

export const RECALL_WS_URL =
  (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('recallWs')) ||
  'wss://meeting-data.bot.recall.ai/api/v1/transcript'

export const VAPI_PUBLIC_KEY = import.meta.env.VITE_VAPI_PUBLIC_KEY as string | undefined

export type BridgeMode = 'translator' | 'instruction' | 'external'

export interface BridgeConfig {
  workspace: string
  assistantId: string
  meetingId: string
  mode: BridgeMode
}

// Logos served as static assets from /logos/ — downloaded from Google Drive
export const WORKSPACE_LOGOS: Record<string, string> = {
  romea: '/logos/romea.png',
  crisalix: '/logos/crisalix.png',
}

export const WORKSPACE_COLORS: Record<string, { primary: string; accent: string }> = {
  romea: { primary: '#FF6B35', accent: '#00C9A7' },
  crisalix: { primary: '#00A8E8', accent: '#00C9A7' },
}
